export enum ModalType {
  NONE = "",
}

export interface ModalState {
  type: ModalType;
  props: any;
}
